import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  EmployeeCarePlanAssignApi,
  EmployeeCareOrderCreateApi,
  EmployeeCareVerifyPaymentApi,
  EmployeeCareEmailVerifyApi,
} from "../../services/Api";
import { useLocation, useNavigate } from "react-router-dom";

function EmployeeCarePlanBuy() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { planId, amount } = state;

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [userId, setUserId] = useState();

  const [noOfUser, setNoOfUser] = useState(1);
  const totalAmount = amount * noOfUser;

  // const totalAmount = 1; for testing purpose

  // 1) Verify email
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter an email address");
      return;
    }
    setLoading(true);
    const response = await EmployeeCareEmailVerifyApi(email);
    setLoading(false);

    if (response.status === "success") {
      toast.success(response.message);
      setIsVerified(true);
      setUserId(response.data.id);
    } else {
      toast.error(response.message || "Email validation failed");
      navigate("/login");
    }
  };

  // 2) Razorpay + assign plan
  const handlePay = async () => {
    // const userData = JSON.parse(localStorage.getItem("userData"));
    // const { name, email: userEmail, phoneNumber: contact } = userData;
    const orderType = "BUSINESSADMIN";

    try {
      const respone = await EmployeeCareOrderCreateApi({
        amount: totalAmount,
        orderType: orderType,
        adminId: userId,
      });
      const orderId =  respone.data.orderId;

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount: totalAmount * 100,
        currency: "INR",
        name: "Good People",
        description: `Employee Care Plan – ₹${totalAmount}`,
        image:
          "https://goodpeople.live/static/media/logo.160934d3c48e5910d916.png",
        order_id: orderId,
        handler: async (data) => {
          console.log('Razorpay payment response',data)
          const res1 = await EmployeeCareVerifyPaymentApi(orderId);
          const res = await EmployeeCarePlanAssignApi({
            planId,
            amount: totalAmount,
            noOfUser,
            adminId: userId,
          });
          if (res.status === "success") {
            toast.success(res.message);
            navigate("/", { replace: true });
          } else if (res.status === "failure" || res.status === "failed") {
            toast.error(res.message);
          } else {
            toast.error("Something went wrong!");
          }
        },
        // prefill: { name, email: userEmail, contact },
        notes: { address: "GoodPeople Corporate Office" },
        theme: { color: "#22BBC7" },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", (resp) => {
        console.error("Payment Failed:", resp);
        toast.error("Payment failed. Please try again.");
      });
      rzp.open();
    } catch (err) {
      console.error(err);
      toast.error("Payment initialization failed. Please try again.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="w-full max-w-lg p-8 bg-white rounded-2xl shadow-xl">
        {!isVerified ? (
          <>
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              Verify Your Email
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <label className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                type="email"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition"
              >
                {loading ? "Verifying…" : "Verify Email"}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">
              Customize Your Seats
            </h2>
            <p className="text-center text-gray-600 mb-6">
              Choose how many user seats you need.
            </p>

            {/* Slider */}
            <div className="mb-8 px-4">
              <input
                type="range"
                min="1"
                max="20"
                value={noOfUser}
                onChange={(e) =>
                  setNoOfUser(Math.max(1, Number(e.target.value)))
                }
                className="w-full h-2 bg-indigo-100 rounded-lg appearance-none cursor-pointer"
              />
              <div className="flex justify-between text-xs text-gray-500 mt-1">
                <span>1</span>
                <span>20</span>
              </div>
            </div>

            {/* Circular Stepper */}
            <div className="flex items-center justify-center space-x-6 mb-8">
              <button
                onClick={() => setNoOfUser((u) => Math.max(1, u - 1))}
                className="w-12 h-12 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full flex items-center justify-center shadow-lg transition"
                aria-label="Decrease users"
              >
                <span className="text-2xl font-bold">−</span>
              </button>

              <div className="w-16 h-16 flex items-center justify-center bg-white border-4 border-indigo-600 rounded-full shadow-inner">
                <span className="text-2xl font-semibold">{noOfUser}</span>
              </div>

              <button
                onClick={() => setNoOfUser((u) => u + 1)}
                className="w-12 h-12 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full flex items-center justify-center shadow-lg transition"
                aria-label="Increase users"
              >
                <span className="text-2xl font-bold">+</span>
              </button>
            </div>

            {/* Total Price */}
            <div className="text-center text-3xl font-bold text-gray-800 mb-8">
              Total: <span className="text-indigo-600">₹{totalAmount}</span>
            </div>

            {/* Pay Button */}
            <button
              onClick={handlePay}
              className="w-full py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition"
            >
              Proceed to Pay
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default EmployeeCarePlanBuy;
